<template>
	<div class="signupSystem">
		 <el-header style="background-color: #616b88;height:80px;">
		 	<div class="header_wrapper">
		 			<img class="header-img"  src="../assets/img/logo1.jpg" >
		 			 <el-dropdown class="login" trigger='click' @command="logout">
			          <span class="el-dropdown-link">欢迎您！{{userInfos.userNickname}} ({{clubInfo.clubName}})<i class="el-icon-arrow-down el-icon--right"></i></span>
			          <el-dropdown-menu slot="dropdown">
			            <el-dropdown-item command="out" >退出</el-dropdown-item>
			          </el-dropdown-menu>
			       </el-dropdown>
		 	</div>

		  </el-header>
		<el-container>

		  <el-main>
				<swiper class="navbar" :options="swiperOption" ref="mySwiper">
					<swiper-slide class="nav audit" >
            <div @click="auditMsg" style="height: 100%;">
              <div class="audit-top" :class="{bgf8:(matchCode == '' || null == matchCode)}" >
                <div class="audit-img">
                  <!--<img  alt="俱乐部logo" src="clubInfo.clubLogo==''?'../assets/img/club_logo.jpg':'clubInfo.clubLogo'" style="width:82px;height: 82px;">-->
                  <div class="audit-left" v-if="clubInfo.clubLogo==''">
                    <img src="../assets/img/club_logo.jpg"  />
                    <h3 class="club_name">
                      {{clubInfo.clubName}}
                    </h3>
                  </div>
                  <div v-else class="audit-left">
                    <img  :src="clubInfo.clubLogo">
                    <h3 class="club_name">{{clubInfo.clubName}}</h3>
                  </div>
                  <p class="audited">已审核</p>
                </div>
              </div>
              <div class="audit-bottom">

                <p>简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：{{clubInfo.clubShortName}} <i v-show="!show1" @click="editClubInfo"class="el-icon-edit-outline" style="float:right">修改</i></p>
                <p>注册日期：{{userInfos.userRegTime | timestampToDate}}</p>
                <p>注册人数：{{clubInfo.regCount}}</p>
                <p>所属地区：{{clubInfo.clubProvinceName}} {{clubInfo.clubCityName}}</p>
                <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：<span style="vertical-align: top;display: inline-block;width:210px;">{{clubInfo.clubAddress}}</span></p>
                <p>联系电话：{{clubInfo.clubContactTel}}</p>
                <p>电子邮箱：{{clubInfo.clubContactEmail}}</p>
                <div class="audit-operation" v-show="!show1">
                  <span class="el-button--primary el-button">运动员管理</span>
                  <span class="el-button--primary el-button" @click.stop="toPersonManage">人员管理</span>
                </div>
              </div>
            </div>

					</swiper-slide>


					<swiper-slide class="nav enrolling audit"  v-for="(item,key) in matchInfo" >
            <div @click="enrollingMsg(item,key)" style="height: 100%;">
              <div class="audit-top"  :class="{bgf8:matchCode==item.matchCode}">
                <div class="audit-img">
                  <!--<img  alt="俱乐部logo" src="clubInfo.clubLogo==''?'../assets/img/club_logo.jpg':'clubInfo.clubLogo'" style="width:82px;height: 82px;">-->
                  <div class="audit-left">
                    <h3 class="club_name" style="margin:auto;margin-top:30px">{{item.leagueName}}</h3>
                  </div>
                  <p class="audited">{{item.matchStatus | matchStatusToData}}</p>
                </div>
              </div>
              <div class="audit-bottom enrolling-bottom">
                <p>{{item.seasonName}}</p>
                <p>{{item.matchName}}</p>
                <p>{{item.matchAddress}}</p>
                <p>{{item.matchStartTime | timestampToDate}} 至 {{item.matchEndTime | timestampToDate}}</p>
                <p v-if="item.matchStatus!=0">报名截止：{{item.signEndTime | timestampToDate1}}</p>
                <p v-if="item.matchStatus!=0">{{calEndTimeArray[key]}}</p>
                <p v-else>未开始</p>
              </div>

              <div class="other">
                <a :href="item.matchRole" target="_blank">赛程规则</a>
                <a :href="item.matchNotice" target="_blank">补充通知</a>
                <p class="el-button--primary el-button atonce"  v-if="signBtnHandel(item.signStartTime,item.signEndTime)">马上报名</p>
              </div>
            </div>

					</swiper-slide>

					<swiper-slide class="nav enrolling audit">
						<div class="audit-top">
							<div class="audit-img">
								<!--<img  alt="俱乐部logo" src="clubInfo.clubLogo==''?'../assets/img/club_logo.jpg':'clubInfo.clubLogo'" style="width:82px;height: 82px;">-->
									<div class="audit-left">
										<h3 class="club_name" style="margin:auto;margin-top:30px">浙江击剑俱乐部联赛</h3>
									</div>
									<p class="audited">敬请期待</p>
							</div>
						</div>
						<div class="audit-bottom enrolling-bottom">
							<h2 style="color:#999;margin-top:80px">敬请期待</h2>
						</div>
					</swiper-slide>


				</swiper>
          <div class="enrollingMsg" v-if="matchCode != '' ">
            <div class="match-info"  v-for="item in matchInfoSingle">
              <div class="match-cell">
                <div style="text-align: center;font-size: 16px;padding-bottom: 10px;">领队信息</div>
                <div v-if="leaderInfo != null && leaderInfo.leaderName != null">
                  <div class="match-cell-item">
                    {{leaderInfo.leaderName}}
                  </div>
                  <div class="match-cell-item">
                    {{leaderInfo.leaderMobile}}
                  </div>
                  <div class="match-cell-item">
                    {{leaderInfo.leaderDuty}}
                  </div>
                </div>
                <div v-else>
                  暂无
                </div>
                <div style="padding-top: 20px;">
                  <el-button type="primary" size="mini" @click="openLeaderDialog">编辑领队信息</el-button>
                </div>
              </div>
              <div style="flex: 2"></div>
              <div class="match-cell">
                <div class="match-cell-item">
              {{item.leagueName}}
            </div>
                <div class="match-cell-item">
              {{item.seasonName}}
            </div>
                <div class="match-cell-item">
              {{item.matchName}}
            </div>
                <div class="match-cell-item">
              {{item.matchAddress}}
            </div>
                <div class="match-cell-item">
              {{item.matchStartTime | timestampToDate}}到{{item.matchEndTime | timestampToDate}}
            </div>
                <div>
              报名截止：{{item.signEndTime | timestampToDate1}}
            </div>

              </div>
              <div style="flex: 2"></div>
              <div class="match-cell" style="text-align: left;">
                <div style="text-align: center;font-size: 16px;padding-bottom: 10px;">注意事项</div>
                <div v-if="null != item.matchAttention && item.matchAttention.length> 0">
                  <el-tooltip class="match-attention" effect="dark" placement="top-start">
                    <div style="width: 600px;" slot="content">{{item.matchAttention}}</div>
                    <div style="padding-left: 10px;padding-right: 10px;">{{item.matchAttention | convertAttention}}</div>
                  </el-tooltip>
                </div>
                <div v-else style="text-align: center;">
                  暂无
                </div>
              </div>
            </div>
            <div class="title-main">
              <h3>{{iconName}}</h3>
            </div>
            <el-menu :default-active="signTab" mode="horizontal"  @select="handleSelect" >

              <el-menu-item index="/personal">个人报名</el-menu-item>
              <el-menu-item index="/group">团体报名</el-menu-item>
              <el-menu-item index="/UnionGroup">联合团体报名</el-menu-item>
              <el-menu-item index="/Parenting">亲子组报名</el-menu-item>
              <el-menu-item index="/hotel">酒店预订</el-menu-item>
              <el-menu-item index="/paymentRecord">缴费记录</el-menu-item>
            </el-menu>

            <div class="title">

            </div>

          </div>
        <div style="margin-top:10px">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
	      </el-main>



	       <el-dialog title="俱乐部信息修改" :visible.sync="editClubInfoShow" width="700px">
			  <el-form :model="clubForm">
			    <el-form-item label="俱乐部简称" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubShortName" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="俱乐部标识" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubLabel" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="网址" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubUrl" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="联系人" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubContactName" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="联系人电话" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubContactTel" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="联系人电子邮箱" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubContactEmail" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="负责人" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubLeadName" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="负责人电话" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubLeadTel" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="地址" :label-width="formLabelWidth">
			      <el-input v-model="clubForm.clubAddress" auto-complete="off"></el-input>
			    </el-form-item>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="editClubInfoShow = false" >取 消</el-button>
			    <el-button type="primary" @click="editClubInfoSure">确 定</el-button>
			  </div>
			</el-dialog>
      <el-dialog
        title="编辑领队信息"
        :visible.sync="leaderDialogVisible"
        width="400px"
        center
        :before-close="closeLeaderDialog">
        <div>
          <el-form :model="leaderHandel" :rules="leaderInfoRules" ref="leaderHandel" label-width="100px" class="demo-ruleForm">
            <el-form-item label="领队姓名" prop="leaderName" size="mini">
              <el-input v-model="leaderHandel.leaderName" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="领队电话" prop="leaderMobile" size="mini">
              <el-input v-model="leaderHandel.leaderMobile" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="领队职务" prop="leaderDuty" size="mini">
              <el-input v-model="leaderHandel.leaderDuty" maxlength="20"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeLeaderDialog" size="mini">取 消</el-button>
          <el-button type="primary" size="mini" @click="sureLeaderInfo">确 定</el-button>
        </span>
      </el-dialog>
		</el-container>
		<el-footer style="text-align: center;height: 120px; font-size: 14px; color: #fff;background-color: #616b88;">
	      		<div class="backup_info" style="padding:40px 0 0px 0;">
	      			孙武击剑版权所有 | 浙ICP17020049号-1 |
	      			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010302003025" style="display:inline-block;text-decoration:none;line-height:20px; color: #fff;" >
	      				<img src="../assets/img/backup_icon.8240878.png" style="vertical-align: middle;float:left;margin-top: 3px;">

				 		公安备案33010302003025
	      			</a>
	      		</div>
	      		<div>
	      			<p>
	      				客服电话：17682314530
	      			</p>
	      		</div>
	      </el-footer>
	</div>
</template>

<script>
	import axios from 'axios'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default{
    components: {
      swiper,
      swiperSlide
    },
		data(){
			return {
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: false
        },
        userInfos: JSON.parse(localStorage.getItem("userInfos")),
        fullscreenLoading: false,
        clubInfo: {},
        matchInfo: [],
        clubName: '',
        isActive: true,
        active: false,
        signEndDate: '',
        show: false,
        show1: false,
        //修改俱乐部信息
        editClubInfoShow: false,
        formLabelWidth: "120px",
        clubForm: {},
        name: '个人报名',
        iconName: '个人报名',
        state: null,
        matchInfoSingle: null,
        matchCode:"",
        signTab:"/personal",
        setTime:[],
        calEndTimeArray:[],
        attentionVisible: false,
        attentionInfo:{
          code: null,
          info: null
        },
        leaderInfo: {},
        leaderHandel: {},
        leaderDialogVisible: false,
        leaderInfoRules: {
          leaderName: [
            { required: true, message: '请输入领队姓名', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字', trigger: 'blur' }
          ],
          leaderMobile: [
            { required: true, message: '请输入领队电话', trigger: 'blur' },
            { min: 11, max: 11, message: '长度为11', trigger: 'blur' }
          ],
          leaderDuty: [
            { required: true, message: '请输入领队职务', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字', trigger: 'blur' }
          ]
        }
      }
		},
    computed: {
      activeMenuIndex() {
        console.log("activeMenuIndex")
        //return this.$store.state.activeMenuIndex;
        if( this.$route.path == '/personal'){
          this.iconName = '个人报名'
        }else if( this.$route.path == '/group'){
          this.iconName = '团体报名'
        }else if( this.$route.path == '/UnionGroup'){
          this.iconName = '联合团体报名'
        }else if( this.$route.path == '/Parenting'){
          this.iconName = '亲子组报名'
        }else if( this.$route.path == '/hotel'){
          this.iconName = '酒店预订'
        }else if( this.$route.path == '/paymentRecord'){
          this.iconName = '缴费记录'
        }
        return this.$store.state.activeMenuIndex;
      },

    },
		filters: {
		    timestampToDate(data) {
		      return global.timestampToDate(data);
		    },
		    timestampToDate1(data,showTime) {
		      return global.timestampToDate(data,true);
		    },
		    matchStatusToData(data){
		    		switch(data){
		    			case 0:
		    				return '筹备中';
		    			break;
		    			case 1:
		    				return '报名中';
		    			break;
		    			case 2:
		    				return '报名截止';
		    			break;
		    			case 3:
		    				return '进行中';
		    			break;
		    			case 4:
		    				return '已结束';
		    			break;
		    		}
		    },
      convertAttention(value){
        let result = ""
        if(null != value && value.length > 0){
          if(value.length > 170){
            result = value.substring(0,170)+'...'
          }else {
            result = value
          }
        }else {
          result = "暂无注意事项"
        }
        return result
      }
		},
		mounted(){
			var self=this

      let matchCode = this.$route.query.matchCode;
			if(undefined != matchCode && null != matchCode && "" != matchCode){
        this.matchCode = matchCode;
        this.signTab = this.$route.path;
      }

      console.log('path',this.$route.path)

      setInterval(self.handleTime, 1000);
			//this.auditMsg()
			//俱乐部信息
		    //比赛列表
		    var postData={
			"pageIndex":1,//页码
			"pageSize":100//数量 ，查询时直接传入此值即可
			}
		    axios.post('/marlin/sign/data/match/query/list',postData)
		    .then(function(res){
		    		if(res.data.code==0){
		    			self.matchInfo=res.data.rst
		    			sessionStorage.setItem("matchInfo", JSON.stringify(res.data.rst));
              //self.handleTime();
              self.queryLeaderInfo()
            }else{
		    			self.$message({
						 message: res.data.msg,
						 type: 'warning'
					});
		    		}
		    })
		    .catch(function(res){
		    		overdue(res.response,res.response.status,self)
		    })
	         this.onSubmitClub();
			  this.enrollingMsg({"matchCode":this.matchCode} , 0);
    },
		methods:{
      toPersonManage(){
        this.$router.push('/personManage')
      },
			onSubmitClub(){
				let self=this
				axios.get('/marlin/sign/club/info/query/single/'+this.userInfos.clubCode)
			    .then(function(res){
			    		if(res.data.code==0){
			    			if(null != res.data.rst && res.data.rst.length==1){
							self.clubInfo=res.data.rst[0]
							self.clubForm=res.data.rst[0]
							sessionStorage.setItem('clubInfos',JSON.stringify(res.data.rst[0]))
			    			}
			    		}else{
			    			self.$message({
							 message: res.data.msg,
							 type: 'warning'
						});
			    		}
			    })
			    .catch(function(res){
			    		overdue(res.response,res.response.status,self)
			    })
			},
      handleSelect(key){
        console.log('key' , key)

        this.$router.push({
          path:key,
          query:{
            matchCode:this.matchCode,
          }
        });
        if( this.$route.path == '/personal'){
          this.iconName = '个人报名'
        }else if( this.$route.path == '/group'){
          this.iconName = '团体报名'
        }else if( this.$route.path == '/UnionGroup'){
          this.iconName = '联合团体报名'
        }else if( this.$route.path == '/Parenting'){
          this.iconName = '亲子组报名'
        }else if( this.$route.path == '/hotel'){
          this.iconName = '酒店预订'
        }else if( this.$route.path == '/paymentRecord'){
          this.iconName = '缴费记录'
        }
      },
      handleTime(){
        let self = this;
        let calEndTimeArray = [];
        if(null != self.matchInfo && self.matchInfo.length > 0){
          for(let i=0;i<self.matchInfo.length;i++){
            if(null != self.matchInfo[i].signEndTime){
              let signEndTimeStr = self.timeSetOut(self.matchInfo[i].signEndTime);
              calEndTimeArray.push(signEndTimeStr)
              this.matchInfo[i].signEndTimeStr = signEndTimeStr;
            }
          }
        }
        this.calEndTimeArray = calEndTimeArray;
      },
      timeSetOut(signEndTime){
        let signTime=null
           let starttime = new Date().getTime();
           let endDate=signEndTime
           let count=endDate-starttime
           let day = Math.floor(count/1000/60/60/24);
           let hour = Math.floor((count/1000/60/60)%24);
           let minute = Math.floor((count/1000/60)%60);
           let second = Math.floor((count/1000)%60);

           if(count>0){
             signTime=day+'天'+hour+'小时'+minute+'分钟'+second+'秒'
             // signTime='未开始'
           }else{
             signTime='报名已截止'
           }
        return signTime
      },
			auditMsg(){
			  console.log(1)
				this.$router.push('/auditMsg')
				this.isActive=true
				this.show=true
				this.show1=false
        this.$store.commit("changeActiveMenuIndex", null);
        this.state=this.$store.state.activeMenuIndex
        this.key=null
        this.matchCode = ""
			},
			enrollingMsg(item,key){
			  let self=this
        this.$store.commit("changeActiveMenuIndex", key);

        this.state=this.$store.state.activeMenuIndex
        axios.get('/marlin/sign/data/match/query/single/'+item.matchCode)
          .then(function (res) {
            console.log(res)
            self.matchInfoSingle=res.data.rst

            self.$store.commit("matchCodeChange",res.data.rst[0].matchCode)
            self.matchCode=self.$store.state.matchCodeMsg
            console.log(self.$route.path)
            if(self.$route.path=='/personal'){
              self.$router.push('/personal?matchCode='+res.data.rst[0].matchCode)
              self.queryLeaderInfo()
            }
            else if(self.$route.path=='/group'){
              self.$router.push('/group?matchCode='+res.data.rst[0].matchCode)
            }
            else if(self.$route.path=='/UnionGroup'){
              self.$router.push('/UnionGroup?matchCode='+res.data.rst[0].matchCode)
            }
            else if(self.$route.path=='/Parenting'){
              self.$router.push('/Parenting?matchCode='+res.data.rst[0].matchCode)
            }
            else if(self.$route.path=='/hotel'){
              self.$router.push('/hotel?matchCode='+res.data.rst[0].matchCode)
            }
            else if(self.$route.path=='/paymentRecord'){
              self.$router.push('/paymentRecord?matchCode='+res.data.rst[0].matchCode)
            }else{
              self.$router.push('/personal?matchCode='+res.data.rst[0].matchCode)
            }
          })
          .catch(function (res) {

          })

				this.show1=true
				this.show=false
				this.isActive=false
			},
			logout(command) {
				let self=this
		      switch (command) {
//		        case "modify":
//		          this.$router.push("/UpdateProfile");
//		          break;
		        case "out":
		        this.$confirm('此操作会退出登录, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	  axios.get('/marlin/sign/logout/normal')
		        	  .then(function(res){
		        	  	if(res.data.code==0){
		        	  		 self.$message({
				            type: 'success',
				            message: '已退出，请重新登录！'
				          });
				        self.$router.push("/");
				    }
		        	  })
		        	  .catch(function(res){
		        	  		overdue(res.response,res.response.status,self)
		        	  })


		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消退出'
		          });
		        });
		        break;
		      }
		    },
		    editClubInfo(){
		    		let self=this
		    		this.editClubInfoShow=true
		    },
		    editClubInfoSure(){
		    		let self=this
		    		let postData={
		    			clubShortName:self.clubForm.clubShortName,
		    			clubLabel:self.clubForm.clubLabel,
		    			clubUrl:self.clubForm.clubUrl,
		    			clubContactName:self.clubForm.clubContactName,
		    			clubContactTel:self.clubForm.clubContactTel,
		    			clubContactEmail:self.clubForm.clubContactEmail,
		    			clubLeadTel:self.clubForm.clubLeadTel,
		    			clubLeadName:self.clubForm.clubLeadName,
		    			clubAddress:self.clubForm.clubAddress,
		    		}
		    		axios.post('/marlin/sign/data/club/info/update/base/info',postData)
		    		.then(function(res){
		    			if(res.data.code==0){
		    				self.$message({
		    					message:"俱乐部信息修改成功！",
		    					type:'success'
		    				})
		    				 self.onSubmitClub()
		    				self.editClubInfoShow=false
		    			}
		    		})
		    		.catch(function(res){

		    		})
		    },
      queryLeaderInfo(){
        let self = this
        let postData = {
          matchCode: this.matchCode,
          clubCode: this.clubInfo.clubCode
        }
        axios.post('/marlin/sign/data/match/leader/query/single',postData)
          .then(function(res){
            if(res.data.code==0 && null != res.data.rst && res.data.rst.length > 0){
              self.leaderInfo = res.data.rst[0]
            }else {
              self.leaderInfo = {}
            }
          })
          .catch(function(res){

          })
      },
      openLeaderDialog(){
        this.leaderDialogVisible = true
        this.leaderHandel.leaderName = this.leaderInfo.leaderName
        this.leaderHandel.leaderMobile = this.leaderInfo.leaderMobile
        this.leaderHandel.leaderDuty = this.leaderInfo.leaderDuty
      },
      closeLeaderDialog(){
        this.leaderDialogVisible = false
      },
      sureLeaderInfo(){
        let self = this
        let postData = this.leaderHandel
        postData.matchCode = this.matchCode
        postData.clubCode = this.clubInfo.clubCode
        axios.post('/marlin/sign/data/match/leader/update',postData)
          .then(function(res){
            if(res.data.code==0 ){
              self.$message({
                message:"编辑成功！",
                type:'success'
              })
              self.queryLeaderInfo()
              self.closeLeaderDialog()
            }
          })
          .catch(function(res){

          })
      },
      signBtnHandel(signStartTime , signEndTime){
        let flag = false
        let now = new Date()
        if(null != signStartTime && null != signEndTime && now.getTime() >= signStartTime && now.getTime() <= signEndTime){
          flag = true
        }
        return flag
      }
		}
	}
</script>

<style scoped lang="less">
.signupSystem{
	background-color:#f0f5fb;
	.header_wrapper{
		width: 1000px;
		margin: auto;
		height:80px;
		.header-img{
			width: 350px;
			margin-top: 10px;
			vertical-align: middle;
		}
		.header-title{
			color: #fff;
			font-size: 22px;
			display: inline-block;
		}
	}
	.el-container{
		width: 1000px;
		margin: auto;
		.el-main{
			padding: 40px 0;
		}

	}
}
	.login{
		float: right;
		color: #fff;
		line-height: 80px;
		background-color:#57607c;
		padding: 0 15px;
	}
	.el-form-item{
			width: 320px;
			display: inline-block;
		}
	.navbar{

		.nav{
			width:300px;
			height: 420px;
			cursor: pointer;
			border-radius: 10px;
			background-color:#fff
		}
		.audit{
			display:flex;
			flex-direction:column;
				.audit-img{


				}
				.audit-left{
					padding:15px 20px;
					display:flex;
					height:95px;
					img{
						width: 41px;
						height:41px;
						margin:20px;
					}
					.club_name{
						font-size:16px;
					}
					p,h3{
						margin: 0;
						font-size: 14px;
						text-align:center;
						margin-top:30px
					}


					.grade{
						margin: 5px 0;
					}
			}
			.audit-bottom{
				flex:2;
				padding: 30px 10px 15px 10px;
				font-weight: normal;
				p{
					margin:10px 0 0 0;
					font-size: 14px;
					color:#6c788e;
				}
				.atonce{
					    padding: 10px 20px;
					    border: 1px solid #44c1de;
					    border-radius: 20px;
					    background-color:#44c1de;
					    cursor: pointer;
					    display: block;
					    width: 176px;
					    margin:15px auto;
					    color:#fff
				}
			}
		}
		.enrolling{
			.enroll{
				padding: 5px 15px;
				text-algin:center;
				border: 1px solid #999;
				font-size: 14px;
				h3{
					text-align:center;
				}
			}
			.enrolling-bottom{
				text-align:center;
			}
			.match{
				text-align: center;
				p{
					margin: 3px;
					font-size: 18px;
				}
			}
			.other{
				text-align: center;
				font-size: 14px;
				padding-bottom:10px;
				a{
				    display: inline-block;
					padding: 5px 15px;
					border: 1px solid #44c1de;
					border-radius: 5px;
					color:#44c1de;
					cursor: pointer;
					margin-bottom: 10px;
					font-size:12px
				}
				.atonce{
					margin: 0 50px;
					padding: 10px 20px;
					border: 1px solid #44c1de;
					border-radius: 20px;
					background-color:#44c1de;
					cursor: pointer;
					display: block;
					width: 176px;
					margin: auto;
					font-size:12px;
					color:#fff;
				}
			}
		}
		.expect{
			display: flex;
			flex-direction: column;
			justify-content: center;
			text-align: center;
		}
	}
.clear:after{
	clear: both;
	display: block;
	visibility: hidden;
	content: '';
	zoom: 1;
}

.el-dropdown-link{
	cursor: pointer;
}
.audit-top{
	flex:1;
	position:relative;
	background-color:#e1e6ef;
	color:#6e7b8e;
	border-top-left-radius:10px;
	border-top-right-radius:10px;
}
.audited{
	width:50px;
	padding: 5px 15px;
	position:absolute;
	left:50%;
	margin-left:-40px;
	bottom:-25px;
	border-radius:5px;
	font-size:12px;
	text-align:center;
	background-color:#fff;
	color:#000
}
.bgf8{
	background-color:#616b88;
	color:#fff
}
.enrollingMsg{
  padding:40px 0 0 0;
}
.matchInfo{
  text-align: center;
  background-color:#fff;
  padding:10px 0;
  color:#666;
}
.matchInfo span{

  display: inline-block;
  margin: 0 5px;
}
.audit-operation{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 20px 0;
  span{
    width: 120px;
    border-radius: 20px;
  }
}
  .match-info{
    display: flex;
    color:#666;
    text-align: center;
    padding-bottom: 20px;
    justify-content: space-between;
    padding-top: 10px;
    font-size: 14px;
  }
  .match-cell{
    padding-top: 20px;
    padding-bottom: 20px;
    border-radius: 10px;
    background-color: #fff;
    flex: 32;
  }
  .match-cell-item{
    padding-bottom: 10px;
  }
  .match-attention{

  }
</style>



// WEBPACK FOOTER //
// src/pages/signupSystem.vue